module.exports = __webpack_public_path__ + "static/mones-6a496f843bc9a47c229c32f128b26400.jpg";